import React from 'react';

const customStyles = {
  container: {
    flexGrow: 1,
    width: '100%',
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    fontSize: '1rem',
    lineHeight: '1.5',
    color: '#495057', // Customize color here
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    border: '1px solid #ced4da',
    borderRadius: '4px', // Customize border-radius here
    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    outline: 'none',
    boxSizing: 'border-box',
    // Additional styles can be added as desired
  },
};

function PostcodeSelect({
  onBlur,
  onChange,
  placeholder = 'Enter UK Postcode',
  selectedValue,
}) {
  const handleInputChange = (event) => {
    onChange && onChange(event.target.value);
  };

  return (
    <div style={customStyles.container}>
      <input
        type="text"
        placeholder={placeholder}
        style={customStyles.input}
        onChange={handleInputChange}
        onBlur={onBlur} //avoid lots of api calls
        value={selectedValue || ''}
      />
    </div>
  );
}

export default PostcodeSelect;
